import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RpTable, { NoData } from 'rp-react-table';
import { sortBy } from 'lodash';
import Switcher from '../../shared/Switcher';
import fixMobileSafariWhiteScreenBug from '../../utils/fixMobileSafariWhiteScreenBug';
import columns from './columns';

class CourseRecords extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { selected: 0 };
    }

    setSelected = (selected) => {
        this.setState({ selected }, () => {
            fixMobileSafariWhiteScreenBug();
        });
    }

    render() {
        const { data: { standardTimes }, params: { id, name } } = this.props;
        const { selected } = this.state;
        const availableTypes = [];

        if (standardTimes.flat) {
            availableTypes.push('flat');
        }
        if (standardTimes.jumps) {
            availableTypes.push('jumps');
        }

        const selectedType = availableTypes[selected];
        const tableData = sortBy(
            standardTimes[selectedType],
            ['distanceYards', 'horseName']
        );

        // selectedType could be empty only if you get here by direct link
        return (
            selectedType ? (
                <section className="cp-courseRecords">
                    {availableTypes.length > 1 ? (
                        <Switcher
                            items={availableTypes}
                            selected={selected}
                            setSelected={this.setSelected}
                        />
                    ) : null}
                    <RpTable
                        columns={columns(name, id, selectedType)}
                        data={tableData}
                    />
                </section>
            ) : (
                <NoData />
            )
        );
    }

}

const recordPropTypes = PropTypes.shape({
    averageTimeSec: PropTypes.number,
    courseRecordHorseName: PropTypes.string,
    distanceYards: PropTypes.number,
    horseCountryOriginCode: PropTypes.string,
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
    noOfFences: PropTypes.number,
    raceDate: PropTypes.string,
    raceInstanceUid: PropTypes.number,
    raceTypeCode: PropTypes.string,
    rpAgesAllowedDesc: PropTypes.string,
    straightRoundJubileeCode: PropTypes.string,
    winnersTime: PropTypes.number,
});

CourseRecords.propTypes = {
    data: PropTypes.shape({
        standardTimes: PropTypes.shape({
            flat: PropTypes.arrayOf(recordPropTypes),
            jumps: PropTypes.arrayOf(recordPropTypes),
        }),
    }).isRequired,
    params: PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
    }),
};

export default CourseRecords;



// WEBPACK FOOTER //
// ./src/js/course/courseRecords/CourseRecords.jsx